import { Component, Input, OnDestroy, OnInit } from '@angular/core';

import { EmitterService } from '../../../../core/utility/services/emitter.service';
import { UtilityService } from '../../../../core/utility/services/utility.service';
import { ColorPalette } from '../../../analytics-core/interfaces/partner.interface';
import { ColorConfig } from '../../../analytics-core/interfaces/widget.interface';
import { ColorUtilityService } from '../../../analytics-core/services/color.utility.service';
import { CONSTANTS, EVENT_EMITTERS } from '../../../analytics/constants/analytics.constants';
import { AnalyticsDataModel } from '../../../analytics/models/analytics.datamodel';
import { AnalyticsService } from '../../../analytics/services/analytics.service';
import { WidgetCore } from '../../interfaces/widget.core.interface';
import { DateRangeBannerService } from '../../services/date-range-banner.service';
import * as _ from 'underscore';
import { hexGrid } from '@turf/turf';
@Component({
	selector: 'app-product-lift-chart',
	styleUrls: ['./product-lift-chart.component.css'],
	templateUrl: './product-lift-chart.component.html'
})
export class ProductLiftChartComponent implements OnInit, WidgetCore, OnDestroy {
	public placeholderimage: string;
	public key: string;
	public timeserieskey: string;
	@Input() sectionclass: string;
	@Input() colorsconfig: any;
	@Input() sectiontitle: string;
	@Input() barchartconfiguration;

	public campaignsList = [];
	public campaignCarouselItem: any;
	public showLoad = true;
	public hasData = false;
	public getDisplayIndex = 0;
	public colorPalette: ColorPalette;
	public reloadSubscription;
	public widgetDataSubscription;
	public widgetTimelineSubscription;
	public isR6Enabled: boolean = false;
	public dateRangeSubscription;
	public isR103: boolean = false;
	public isR104: boolean = false;
	public showDateRangeBanner = false;
	constructor(
		protected analyticsService: AnalyticsService,
		protected colorUtilityService: ColorUtilityService,
		protected analyticsDataModel: AnalyticsDataModel,
		protected dateRangeBannerService: DateRangeBannerService
	) {
		this.reloadSubscription = EmitterService.get(EVENT_EMITTERS.RELOAD).subscribe((response: any) => {
			this.requestData();
		});
		this.dateRangeSubscription = EmitterService.get(EVENT_EMITTERS.DATE_RANGE).subscribe((dateRange: any) => {
			this.showDateRangeBanner = this.dateRangeBannerService.checkDateRangeBanner(dateRange);
		});
	}

	ngOnInit(): void {
		this.barchartconfiguration = JSON.parse(decodeURI(this.barchartconfiguration));
		this.isR103 =
			this.analyticsDataModel.config.partner.directoryName === 'default-r103' ||
			this.analyticsDataModel.config.partner.directoryName === 'entravision-r103'
				? true
				: false;
		this.isR104 = this.analyticsDataModel.config.partner.directoryName === 'default-r104' ? true : false;
		if (this.sectionclass.toLowerCase().includes('r6') || this.sectionclass.toLowerCase().includes('v6')) {
			this.isR6Enabled = true;
		}
		this.requestData();
		this.colorsconfig =
			typeof this.colorsconfig === 'string' ? JSON.parse(decodeURI(this.colorsconfig)) : this.colorsconfig;
		this.colorPalette = this.analyticsDataModel.partner.colorPalette;
	}

	ngOnDestroy(): void {
		if (this.reloadSubscription) {
			this.reloadSubscription.unsubscribe();
		}
		if (this.widgetDataSubscription) {
			this.widgetDataSubscription.unsubscribe();
		}
		if (this.widgetTimelineSubscription) {
			this.widgetTimelineSubscription.unsubscribe();
		}
		if (this.dateRangeSubscription) {
			this.dateRangeSubscription.unsubscribe();
		}
	}

	requestData(): void {
		this.showLoad = true;
		this.hasData = false;
		this.widgetDataSubscription = this.analyticsService.processWidgetRequest(this.key).subscribe((res: any) => {
			if (res.success && res.data.length > 0 && this.verifyCampaignStatus(res.data)) {
				this.campaignsList = res.data;
				const campaignListTemp = res.data;
				this.hasData = true;
				this.widgetTimelineSubscription = this.analyticsService
					.processWidgetRequest(this.timeserieskey)
					.subscribe((response: any) => {
						this.showLoad = false;
						if (response.success && response.data.length > 0) {
							this.campaignsList = campaignListTemp;
							this.campaignsList.map((campaignItem) => {
								campaignItem.data = response.data.filter((obj) => obj.campaign_id === campaignItem.campaign_id);
							});
						} else {
							this.hasData = false;
							this.campaignsList = [];
						}
						this.processResponseData();
						this.campaignCarouselItem = this.campaignsList[this.getDisplayIndex];
						this.getToolTip();
						// Check banner when new data is received (for tab switching)
						this.showDateRangeBanner = this.dateRangeBannerService.shouldShowBannerForDateRange(
							this.analyticsDataModel.startDate,
							this.analyticsDataModel.endDate
						);
					});
			} else {
				this.showLoad = false;
				this.hasData = false;
			}
		});
	}

	processResponseData(): void {
		this.campaignsList = this.campaignsList.map((campaignItem, index) => {
			const campaign = {
				average_baseline: campaignItem.average_baseline,
				average_exposed_rate: campaignItem.average_conversion_rate,
				average_lift: campaignItem.average_lift,
				campaign_id: campaignItem.campaign_id,
				graphData: [],
				id: campaignItem.campaign_id,
				legendLayout: {},
				name: campaignItem.campaign_name,
				subtitle: {},
				title: {},
				xAxis: {},
				height: Number,
				width: Number,
				yAxisPrimary: {},
				yAxisSecondary: {},
				margin: Number
			};
			const baseline_data = [];
			const exposed_rate = [];
			const lift_data = [];
			const xAxisObj: any = {};
			const categories = [];
			campaignItem.data.forEach((dataObj) => {
				if (dataObj.average_baseline.match(/^</)) {
					baseline_data.push({
						str: '&lt;',
						y: Number(dataObj.average_baseline.substr(1))
					});
				} else {
					baseline_data.push({
						str: '',
						y: Number(dataObj.average_baseline)
					});
				}

				// baseline_data.push(Number(dataObj.average_baseline));
				exposed_rate.push(Number(dataObj.average_conversion_rate));
				lift_data.push(this.buildLiftDataObject(dataObj));
				categories.push(dataObj.impression_date);
			});
			xAxisObj.labels = {
				rotation: this.isR104
					? null
					: this.barchartconfiguration?.xAxisConfig?.labels?.rotation
					? this.barchartconfiguration.xAxisConfig.labels.rotation
					: -45
			};
			xAxisObj.categories = categories;
			campaign.xAxis = xAxisObj;
			if (this.isR103 || this.isR104) {
				campaign.yAxisPrimary['labels'] = {
					// tslint:disable-next-line: object-literal-shorthand
					formatter: function (): string {
						return '<div align="center" style="width:100px">' + this.value + 'x' + '&nbsp;' + 'Lift</div>';
						// return this.value + 'x Lift';
					}
				};
			} else {
				campaign.yAxisPrimary['labels'] = {
					// tslint:disable-next-line: object-literal-shorthand
					formatter: function (): string {
						return this.value + 'x';
					}
				};
			}
			campaign.yAxisSecondary['labels'] = {
				formatter() {
					return this.value + '%';
				},
				x: 7
			};
			campaign.graphData = [
				{
					color: this.getColorFromColorConfig(0, 1),
					data: exposed_rate,
					fillColor: this.getColorFromColorConfig(0),
					name: 'Exposed Rate',
					type: 'area'
				},
				{
					color: this.getColorFromColorConfig(1, 1),
					data: baseline_data,
					fillColor: this.getColorFromColorConfig(1),
					name: 'Baseline Rate',
					type: 'area',
					useHTML: true
				},
				{
					color: this.getColorFromColorConfig(2, 1),
					data: lift_data,
					name: 'Lift',
					type: 'column',
					yAxis: 1
				}
			];
			campaign.height = this.barchartconfiguration?.svgHeight ? this.barchartconfiguration?.svgHeight : 300;
			campaign.width = this.barchartconfiguration?.svgWidth ? this.barchartconfiguration?.svgWidth : null;
			campaign.margin = this.barchartconfiguration?.margin ? this.barchartconfiguration?.margin : [40, 60, 60, 50];
			return campaign;
		});
		this.configGraphOptions();
	}

	buildLiftDataObject(dataObject: any): any {
		const liftTempObj: any = {};
		if (Number(dataObject.average_lift.replace(/,/g, '')) > 99) {
			liftTempObj.displayLift = '>99';
			liftTempObj.str = '&gt;';
			liftTempObj.y = 99;
		} else {
			liftTempObj.displayLift = dataObject.average_lift;
			liftTempObj.y = parseInt(dataObject.average_lift, 10);
		}
		return liftTempObj;
	}

	public configGraphOptions(): void {
		this.campaignsList.forEach((campaign, index) => {
			campaign.width = this.barchartconfiguration?.width ? this.barchartconfiguration?.width : '';
			campaign.average_exposed_rate =
				UtilityService.isUndefinedOrNull(campaign.average_exposed_rate) || Number(campaign.average_exposed_rate) === 0
					? '<0.01'
					: campaign.average_exposed_rate;
			campaign.average_baseline =
				UtilityService.isUndefinedOrNull(campaign.average_baseline) || Number(campaign.average_baseline) === 0
					? '<0.01'
					: campaign.average_baseline;
			if (this.isR104) {
				campaign.legendLayout = {
					align: 'right',
					floating: true,
					itemStyle: {
						fontSize: '10px'
					},
					layout: this.barchartconfiguration?.legendConfig?.layout
						? this.barchartconfiguration.legendConfig.layout
						: 'vertical',
					symbolHeight: 12,
					symbolWidth: 12,
					symbolRadius: 2,
					verticalAlign: this.barchartconfiguration?.legendConfig?.verticalAlign
						? this.barchartconfiguration.legendConfig.verticalAlign
						: 'top',
					x: -10,
					y: -40,
					labelFormatter: function () {
						if (this.name == 'Exposed Rate') {
							return (
								this.name + '&nbsp&nbsp  <span class="legend-metrics">' + campaign.average_exposed_rate + '% </span>'
							);
						} else if (this.name == 'Baseline Rate') {
							return this.name + '&nbsp&nbsp  <span class="legend-metrics">' + campaign.average_baseline + '% </span>';
						} else if (this.name == 'Lift') {
							return (
								this.name +
								'&nbsp&nbsp  <span class="legend-metrics">' +
								(Number(campaign.average_lift) > 99 ? '>99' : Number(campaign.average_lift)) +
								'x </span>'
							);
						}
					}
				};
			} else {
				campaign.legendLayout = {
					align: 'right',
					floating: true,
					itemStyle: {
						fontSize: '10px'
					},
					layout: this.barchartconfiguration?.legendConfig?.layout
						? this.barchartconfiguration.legendConfig.layout
						: 'vertical',
					symbolHeight: 7,
					symbolWidth: 7,
					verticalAlign: this.barchartconfiguration?.legendConfig?.verticalAlign
						? this.barchartconfiguration.legendConfig.verticalAlign
						: 'top',
					x: -10,
					y: -40
				};
			}
			campaign.title = {
				text: null
			};
			campaign.plotOptions = {
				area: {
					marker: {
						enabled: false
					}
				},
				column: {
					borderWidth: 0,
					pointWidth: 15,
					borderRadius: this.barchartconfiguration?.series?.borderRadius
						? this.barchartconfiguration.series.borderRadius
						: 0
				},
				series: {
					states: {
						inactive: {
							opacity: 1
						}
					}
				}
			};
			campaign.subtitle = {
				align: this.barchartconfiguration?.graphSubTitle ? this.barchartconfiguration.graphSubTitle : 'left',
				style: {
					color: '#455a64',
					fontSize: '10px'
				},
				text:
					// tslint:disable-next-line: prefer-template
					'<b>Lift: </b>' +
					(Number(campaign.average_lift) > 99 ? '>99' : Number(campaign.average_lift)) +
					'x  ' +
					' <b>Exposed Rate: </b>' +
					campaign.average_exposed_rate +
					'%    <b>Baseline Rate: </b>' +
					campaign.average_baseline +
					'%',
				useHTML: true
			};
		});
	}

	prevArrow(): void {
		if (this.campaignsList.length > 1) {
			if (this.getDisplayIndex === 0) {
				this.getDisplayIndex = this.campaignsList.length - 1;
			} else {
				this.getDisplayIndex = this.getDisplayIndex - 1;
			}
			this.campaignCarouselItem = this.campaignsList[this.getDisplayIndex];
			this.getToolTip();
		}
	}

	nextArrow(): void {
		if (this.campaignsList.length > 1) {
			if (this.campaignsList.length - 1 === this.getDisplayIndex) {
				this.getDisplayIndex = 0;
			} else {
				this.getDisplayIndex = this.getDisplayIndex + 1;
			}
			this.campaignCarouselItem = this.campaignsList[this.getDisplayIndex];
			this.getToolTip();
		}
	}

	getToolTip(): void {
		const r6Enabled = this.isR6Enabled;
		// tslint:disable-next-line: no-this-assignment
		const self = this;
		if (this.campaignCarouselItem) {
			this.campaignCarouselItem['tooltip'] = {
				backgroundColor: r6Enabled ? '#f7f7f7' : '#f7f7f7',
				borderColor: r6Enabled ? 'rgba(221, 225, 227, 0.75)' : undefined,
				borderRadius: r6Enabled ? 4 : 3,
				borderWidth: r6Enabled ? 0 : 1,
				// tslint:disable-next-line: object-literal-shorthand
				formatter: function (): string {
					if (this.series.name === 'Lift' && !r6Enabled) {
						return (
							// tslint:disable-next-line: prefer-template
							'<div style="position:relative; top:10px"><span style="font-size:10px !important">' +
							this.x +
							'</span><br/>' +
							this.series.name +
							': <b>' +
							this.y +
							'x Lift </b></div>'
						);
					} else if (!this.series.name.includes('Rate') && r6Enabled) {
						return (
							// tslint:disable-next-line: prefer-template
							`<div class="r6-lift-tooltip"><div class="primary-color">` +
							this.x +
							'</div><div style="padding-top:10px">' +
							this.series.data[this.point.index].displayLift +
							'x</div><div style="padding-top:10px">' +
							this.series.name +
							'</div></div>'
						);
					} else if (this.series.name.includes('Rate') && r6Enabled && this.y !== 0) {
						return (
							// tslint:disable-next-line: prefer-template
							`<div class="r6-lift-tooltip"><div class="primary-color">` +
							this.x +
							'</div><div style="padding-top:10px">' +
							this.y +
							'%</div><div style="padding-top:10px">' +
							this.series.name +
							'</div></div>'
						);
					} else if (this.series.name.includes('Rate') && r6Enabled && this.y === 0) {
						return (
							// tslint:disable-next-line: prefer-template
							`<div class="r6-lift-tooltip"><div class="primary-color">` +
							this.x +
							'</div><div style="padding-top:10px">0.00%</div><div style="padding-top:10px">' +
							this.series.name +
							'</div></div>'
						);
					} else {
						return (
							// tslint:disable-next-line: prefer-template
							'<div style="position:relative; top:10px"><span style="font-size:10px !important">' +
							this.x +
							'</span><br/>' +
							this.series.name +
							': <b>' +
							self.checkForNullTooltipValue(this.y) +
							'%</b></div>'
						);
					}
				},
				useHTML: true
			};
		}
	}

	getColorFromColorConfig(index: number, opacity?: number): string {
		const colorConfig: ColorConfig = this.colorsconfig[index];
		const fillOpacity = opacity ? opacity : colorConfig.opacity;
		let rgb = '';
		if (colorConfig.isHex) {
			rgb = this.colorUtilityService.getRGBByOpacity(colorConfig.color, fillOpacity);
		} else {
			rgb = this.colorUtilityService.getRGBByColorType(this.colorPalette, colorConfig.color, fillOpacity);
		}
		return rgb;
	}
	checkForNullTooltipValue(value: any): any {
		if (UtilityService.isUndefinedOrNull(value) || value === 0) {
			return '&lt;0.01';
		}
		return value;
	}

	verifyCampaignStatus(campaignList: any[]): boolean {
		let status = false;
		if (this.isR6Enabled) {
			status = campaignList.reduce((acc, value, i) => {
				return acc || UtilityService.toTrueOrFalse(value['show_lift_data']);
			}, status);
		} else {
			status = true;
		}
		return status;
	}
}
